$shm_hitalama_card $mol_view
	dom_name \section
	title \
	content /$mol_view_content
	sub /
		<= Head $mol_view
			dom_name \header
			sub /
				<= Title $mol_view
					dom_name \h3
					sub /
						<= title
		<= Body $mol_view
			sub <= content
